import React from 'react';
import {
  StyleSheet,
  View,
  Text,
  TextInput,
} from './components/base_components';
import { BusyOverlay, useBusy } from './components/busy_component';
import ProgressSpinner from './components/progress_spinner';
import Header from './components/header';
import DialogScreen from './components/dialog_screen';
import TextButton from './components/buttons/text_button';

import VolumeListScreen from './volume_list_screen';

import OrgStore from './stores/org_store';
import UserStore from './stores/user_store';

const styles = StyleSheet.create({
  homeScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  body: {
    flex: 1,
    alignSelf: 'stretch',
  },
  title: {
    color: '#333',
    fontSize: '2rem',
    fontWeight: '600',
  },
  subtitle: {
    marginTop: '1rem',
    color: '#333',
    fontSize: '1.5rem',
    fontWeight: '400',
  },
  input: {
    alignSelf: 'stretch',
    marginTop: '1rem',
    paddingLeft: '1rem',
    paddingRight: '1rem',
    height: '4rem',
    color: '#555',
    fontSize: '1.5rem',
    borderRadius: '0.5rem',
    borderWidth: 1,
    borderColor: '#555',
    backgroundColor: '#f1f1f1',
  },
  button: {
    alignSelf: 'flex-end',
    marginTop: '1rem',
  },
});

export default function HomeScreen() {
  const user = UserStore.useUser();
  const [org_name, setOrgName] = React.useState('');
  const [is_busy, setBusy, clearBusy] = useBusy();

  function _onCreatePress() {
    if (org_name && setBusy()) {
      OrgStore.createOrg({ org_name }, (err) => {
        if (err === 409) {
          window.alert('Organization name already in use.');
        } else if (err) {
          window.alert('Create failed, please try again.');
        } else {
          window.alert('Org created!');
        }
        clearBusy();
      });
    }
  }

  let content: any = null;
  if (!user) {
    content = <ProgressSpinner />;
  } else if (user?.org_list?.length > 0) {
    content = <VolumeListScreen />;
  } else {
    content = (
      <>
        <Header />
        <View style={styles.body}>
          <DialogScreen>
            <Text style={styles.title}>Welcome to Maxlo</Text>
            <Text style={styles.subtitle}>
              It looks like you're not a member of an Organization yet.
            </Text>
            <Text style={styles.subtitle}>
              If you have an organization administrator, ask them to add your
              email to the organization.
            </Text>
            <Text style={styles.subtitle}>
              Otherwise you can create a new organization now.
            </Text>
            <TextInput
              style={styles.input}
              placeholder='Organization Name'
              value={org_name}
              onChangeText={setOrgName}
            />
            <TextButton
              style={styles.button}
              text='Create Organization'
              onPress={_onCreatePress}
            />
          </DialogScreen>
        </View>
        <BusyOverlay isBusy={is_busy} />
      </>
    );
  }

  return <View style={styles.homeScreen}>{content}</View>;
}
